import React from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';

const NewsCategoryForm = ({ initials, handleSubmit }) => {
  const { t } = useTranslation();

  return (
    <Form onFinish={handleSubmit} initialValues={initials}>
      <CollapseBlock title={t('Obsah')}>
        <FormTextField label={t('Názov')} name={'name'} rules={[required(t)]} />

        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'news-categories'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </CollapseBlock>
    </Form>
  );
};

NewsCategoryForm.propTypes = {
  initials: PropTypes.object,
  handleSubmit: PropTypes.func,
};

export default NewsCategoryForm;
